import { render, staticRenderFns } from "./subdevices.vue?vue&type=template&id=7127067d&scoped=true&"
import script from "./subdevices.vue?vue&type=script&lang=js&"
export * from "./subdevices.vue?vue&type=script&lang=js&"
import style0 from "./subdevices.vue?vue&type=style&index=0&id=7127067d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7127067d",
  null
  
)

export default component.exports